export default {
  mimeTypeSettingsHeader: 'Ustawienia {mimeType}',
  contentTypeSettingsHeader: 'Ustawienia treści',
  title: 'Eksportuj {MIMEType}',
  submitLabel: 'Eksportuj {MIMEType}',
};
